module.exports = __webpack_public_path__ + "img/leaderboard-header.149883df.jpg";